<template>
  <div class="wrp">
    <PotentialClientProfile :leadSn="leadSn" :staffId="staff.staffid"></PotentialClientProfile>
  </div>
</template>

<script>
import PotentialClientProfile from "../components/Main/PotentialClientProfile";
export default {
  components: {
    PotentialClientProfile
  },
  data() {
    return {
      staff: "",
      leadSn: ""
    };
  },
  created() {
    document.title = "修改基本資料";
    this.staff = this.GetLoginStaff();
    this.leadSn = this.$route.query.ls;
  },
  methods: {}
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobilePotentialClientProfileView.vue